export const recaptchaServiceValidation = async (verifyCaptchaResponse) => {
  let result = {
    isValid: false,
    error : {
      message1: "",
      message2: ""
    }
  }
  if (verifyCaptchaResponse && verifyCaptchaResponse.success) {
    result.isValid = true;
  } else {
    result.isValid = false;
  }
  return result;
};
